module.exports = __webpack_public_path__ + "static/media/order_type_facebook.3f0b75b5.svg";